/* eslint-disable no-unused-vars */
import React from 'react';
import './InviteCard.css';

import Button from "./Button";

function InviteCard() {
  const queryParameters = new URLSearchParams(window.location.search)
  // const geo = queryParameters.get("geo")

  const link = "tg://join?invite=6dNeD9Qt2Kw2Y2Yx";
  
  return (
    <div className="invite-card">
      <div className="invite-card-content">
        <img src={require("./logo.jpg")} alt="AP2P crypto" className="channel-logo" />
        <h1 className="channel-name">Записи Олексія ✍🏻</h1>
        <p className="channel-handle">11 598 subscribers</p>
        {/* <p className="channel-description">
        ⚡️ Заявка прийнята автоматично!
        </p> */}
        <p className="channel-description">
        Привіт, я Олексій (<strong>@oleksiy_blog</strong>), в своєму каналі я нічого не продаю і просто безкоштовно показую  ...
        </p>
        <p className="channel-description">
          {/* Менеджер: <strong>@p2pcrypto_manager</strong> */}
          Не віриш? Підписуйся і перевірь сам ⤵️
        </p>
          <Button className="channel-link" text="перейти на канал" link={link} type="msg" />
      </div>
    </div>
  );
}

export default InviteCard;
